import { Chip, type SxProps, type Theme } from '@mui/material';

import { Request, type AttendanceStatus as AttendanceStatusType } from '../../models';

interface AttendanceStatusProps {
	attendanceStatus: AttendanceStatusType;
	sx?: SxProps<Theme>;
}

interface StatusStyle {
	backgroundColor: string;
}

const unknownStatus = 'unknown';

const labels: Record<string, string> = {
	...Request.attendanceStatusLabel,
	[unknownStatus]: 'Unknown',
};

const style: Record<string, StatusStyle> = {
	[Request.attendanceStatus.pending]: {
		backgroundColor: '#FEF08A',
	},
	[Request.attendanceStatus.attendedOnTime]: {
		backgroundColor: '#6EE7B7',
	},
	[Request.attendanceStatus.didNotAttend]: {
		backgroundColor: '#FFA2A8',
	},
	[Request.attendanceStatus.rescheduled]: {
		backgroundColor: '#FFC790',
	},
};

export const AttendanceStatus = ({ attendanceStatus }: AttendanceStatusProps) => {
	const resolvedStatus = style[attendanceStatus] ? attendanceStatus : unknownStatus;

	return (
		<Chip
			label={labels[resolvedStatus]}
			sx={{
				...style[resolvedStatus],
				fontWeight: 'bold',
				color: '#000',
				borderRadius: '14px',
				fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.875rem' },
				'&.MuiChip-root': {
					borderRadius: '5px',
				},
			}}
		/>
	);
};
